<div class="flex">
  @if (period.from && period.to) {
    <span class="subtitle3Font"
          i18n>Edit period:</span>
    <span class="ml-2">{{ period.from | date:'y-m-d' }} - {{ period.to | date:'y-m-d' }}</span>
  }

  @if (!period.from && period.to) {
    <span class="subtitle3Font"
          i18n>Edit period to:</span>
    <span class="ml-2"
          i18n>{{ period.to | date:'y-m-d' }}</span>
  }

  @if (period.from && !period.to) {
    <span class="subtitle3Font"
          i18n>Edit period from:</span>
    <span class="ml-2"
          i18n>{{ period.from | date:'y-m-d' }}</span>
  }

  @if (daysLeft > 0) {
    <span class="ml-5 font-bold"
          i18n>
      <i class="mr-1 fas fa-clock"></i>
      {{ daysLeft }} days left
    </span>
  }
</div>